import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchJSON } from '../../../../../../utils/hooks/useFetchJson'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalRecalculateQuoteProps extends ModalEditComponentProps {}

const ModalRecalculateQuote: React.FC<ModalRecalculateQuoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/quote/recalculatePricesQuoteOrder',
        data: allRowData?.header || {}
    })

    const { handleFetchJSONLoading, loading } = useModalRecalculateQuoteOrderLogic({ handleFetchJSON })

    return (
        <ModalSmallFilled opened={true} loading={loading} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchJSONLoading} translations={{
            title: t('sureRecalcualteQuote', '¿Seguro que quieres recalcular este presupuesto?'),
            subtitle: t('recalculateProductPrices', 'Recalculará los precios de los productos'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

interface ModalRecalculateQuoteOrderLogicProps {
    handleFetchJSON: () => Promise<void>
}

const useModalRecalculateQuoteOrderLogic = ({ handleFetchJSON }: ModalRecalculateQuoteOrderLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleFetchJSONLoading = useCallback(async () => {
        startLoading()
        await handleFetchJSON()
        endLoading()
    }, [startLoading, handleFetchJSON, endLoading])
    return { handleFetchJSONLoading, loading }
}

export default ModalRecalculateQuote